/**
 * NotesTab Component
 *
 * Wrapper component for displaying asset notes in the AssetDrawer.
 * Provides a container with proper styling for the Notes component.
 *
 * Modal Integration:
 * - Uses the drawer's centralized NoteModal (AssetDrawerModals)
 * - "New Note" button triggers setIsCommentModalOpen(true)
 * - Modal appears as overlay, not embedded in drawer
 */

import { Container } from '@/components/ui';
import { Notes } from '@/sections/Notes';
import { Asset } from '@/types';

interface NotesTabProps {
  /** The asset to display notes for */
  asset: Asset;
  /** Opens the drawer's comment modal when called */
  onOpenCommentModal?: () => void;
}

/**
 * NotesTab displays notes associated with a specific asset
 *
 * @param asset - The asset object containing notes data
 * @param onOpenCommentModal - Handler to open the drawer's comment modal
 */
export function NotesTab({ asset, onOpenCommentModal }: NotesTabProps) {
  return (
    <Container className="size-full overflow-auto p-6" tabIndex={-1} id="notes">
      <Notes
        resource={asset}
        resourceType="Asset"
        onOpenCommentModal={onOpenCommentModal}
      />
    </Container>
  );
}
